import React from 'react';

import { Popover } from 'antd';

import { getMoment, showDateNoTime } from '@libs/NwMoment';

import { NwTag } from '@components/Gui/NwTag';

// Component to display event dates as tags
const ModelsAvailabilityEventDatesTags = ({ eventDates }) => {
    // Helper function to check if dates are consecutive/subsequent
    const areDatesConsecutive = (dates) => {
        if (dates.length <= 1) return false;

        const sortedDates = [...dates].sort();
        for (let i = 1; i < sortedDates.length; i++) {
            const prevDate = getMoment(sortedDates[i - 1]);
            const currDate = getMoment(sortedDates[i]);
            const diffDays = currDate.diff(prevDate, 'days');
            if (diffDays !== 1) {
                return false;
            }
        }
        return true;
    };

    if (!eventDates || eventDates.length === 0) {
        return <small>No event dates</small>;
    }

    const sortedDates = [...eventDates].sort();
    const firstDate = sortedDates[0];
    const lastDate = sortedDates[sortedDates.length - 1];
    const isConsecutive = areDatesConsecutive(sortedDates);

    // Case 1: More than 6 dates and NOT consecutive - show summary with popover
    if (eventDates.length > 6 && !isConsecutive) {
        const content = (
            <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                {sortedDates.map((date, index) => (
                    <p key={index} style={{ margin: '0.25rem 0' }}>
                        {showDateNoTime(date)}
                    </p>
                ))}
            </div>
        );

        return (
            <Popover content={content} title="Event Dates" placement="bottom">
                <span>
                    <NwTag pointer>
                        {eventDates.length} dates between {showDateNoTime(firstDate)} and {showDateNoTime(lastDate)}
                    </NwTag>
                </span>
            </Popover>
        );
    }

    // Case 2: Consecutive dates and more than 2 - show range
    if (isConsecutive && eventDates.length > 2) {
        return (
            <NwTag>
                from {showDateNoTime(firstDate)} to {showDateNoTime(lastDate)}
            </NwTag>
        );
    }

    // Case 3: Show individual date tags
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
            {sortedDates.map((date, index) => (
                <NwTag key={index}>{showDateNoTime(date)}</NwTag>
            ))}
        </div>
    );
};

export default ModelsAvailabilityEventDatesTags;
